import type { PasswordSignInUserCountPayload } from '@Application/Security/Sso/Actions/passwordSignInUserCountFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Carries its own scope (`accountId`) so `stopOn` can compare the cached count against the account
 * currently on screen without a companion field in the store.
 */
class PasswordSignInUserCountView {
	readonly passwordSignInUserCount: number;
	readonly accountId: number;

	constructor(payload: PasswordSignInUserCountPayload, accountId: number) {
		this.passwordSignInUserCount = payload.passwordSignInUserCount;
		this.accountId = accountId;

		Object.freeze(this);
	}
}

export default PasswordSignInUserCountView;
